import React from 'react';

/** The Rayogent mark: a saffron outlined tile with a power tower (10^10^10, after Rayo's number), and the wordmark. */
export default function Logo({ size = 'md', withWord = true }) {
  const tile = size === 'sm' ? 'w-7 h-7 rounded-lg' : size === 'lg' ? 'w-10 h-10 rounded-xl' : 'w-9 h-9 rounded-xl';
  const word = size === 'sm' ? 'text-base' : size === 'lg' ? 'text-2xl' : 'text-xl';
  return (
    <span className="inline-flex items-center gap-2">
      <span className={`${tile} bg-brand border-2 border-ink shadow-neo-sm flex shrink-0 overflow-hidden`}>
        <svg width="100%" height="100%" viewBox="0 0 100 100" fill="#141414" aria-hidden="true">
          <rect x="12" y="52" width="32" height="32" rx="6" />
          <rect x="48" y="32" width="22" height="22" rx="4.5" />
          <rect x="74" y="18" width="14" height="14" rx="3" />
        </svg>
      </span>
      {withWord && <span className={`${word} font-heading font-extrabold tracking-tight text-foreground`}>Rayogent</span>}
    </span>
  );
}
